import { render } from "./CreateEditUser.vue?vue&type=template&id=2f38bb6b&scoped=true"
import script from "./CreateEditUser.vue?vue&type=script&lang=js"
export * from "./CreateEditUser.vue?vue&type=script&lang=js"

import "./CreateEditUser.vue?vue&type=style&index=0&id=2f38bb6b&scoped=true&lang=css"
import "./CreateEditUser.vue?vue&type=style&index=1&id=2f38bb6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f38bb6b"]])

export default __exports__